import { render, staticRenderFns } from "./Blood.vue?vue&type=template&id=60588bc5"
import script from "./Blood.vue?vue&type=script&lang=js"
export * from "./Blood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports